import { Text } from "@chakra-ui/react";

export const FieldError = ({ children }: { children: string | undefined }) => (
  <Text color="red.500" fontSize="sm" mt={"4px"} minHeight={"21px"}>
    {children}
  </Text>
);
